<template>
    <div
        class="lg:flex lg:h-full lg:flex-col px-5 py-5 lg:px-6 lg:py-6 min-h-[220px] relative"
    >
        <CalendarTabs :tabs="calTabs" v-if="!loading" />
        <div v-if="activeTab === 'list' && !loading">
            <CalendarListRange :size="size" :hide-past-dates="true" />
        </div>
        <div v-if="activeTab === 'calendar' && !loading">
            <CalendarControls />
            <CalendarDay :size="size" v-if="view === 'day'" />
            <CalendarList
                :size="size"
                :hide-past-dates="true"
                v-if="view === 'list'"
            />
            <CalendarMonth
                :size="monthSize"
                :hide-past-dates="true"
                v-if="view === 'month'"
            />
            <CalendarYear :size="size" v-if="view === 'year'" />
        </div>
        <Loading :loading="loading" />
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useCalendarStore } from '@/store/calendar';

import CalendarTabs from '@/components/calendar/tabs.vue';
import CalendarControls from '@/components/calendar/controls.vue';
import CalendarMonth from '@/components/calendar/views/month.vue';
import CalendarDay from '@/components/calendar/views/day.vue';
import CalendarList from '@/components/calendar/views/list.vue';
import CalendarListRange from '@/components/calendar/views/list-range.vue';
import CalendarYear from '@/components/calendar/views/year.vue';
import Loading from '@/components/ui/loading-state/loading-state.vue';

export default {
    name: 'AvailabilityCalendar',
    data: () => ({
        monthSize: 'full',
    }),
    props: {
        size: {
            type: String,
            default: 'full',
        },
    },
    components: {
        CalendarTabs,
        CalendarControls,
        CalendarMonth,
        CalendarDay,
        CalendarList,
        CalendarListRange,
        CalendarYear,
        Loading,
    },
    watch: {
        activeDate() {
            this.setPreloadedYear(false);
        },
    },
    computed: {
        ...mapState(useCalendarStore, [
            'loading',
            'view',
            'activeTab',
            'setView',
        ]),
        calTabs() {
            return [
                { name: 'list', label: 'Your travel dates' },
                {
                    name: 'calendar',
                    label: 'Availability calendar',
                    icon: 'calendar-availability',
                },
            ];
        },
    },
    methods: {
        ...mapActions(useCalendarStore, ['setPreloadedYear']),
    },
    mounted() {
        const mobileWidth = 768;
        let viewportWidth = window.innerWidth;
        if (viewportWidth < mobileWidth) {
            this.monthSize = 'mini';
            if (this.view === 'year') {
                this.setView({ name: 'day', label: 'Day' });
            }
        }
        window.addEventListener('resize', () => {
            viewportWidth = window.innerWidth;
            if (viewportWidth < mobileWidth) {
                this.monthSize = 'mini';
                if (this.view === 'year') {
                    this.setView({ name: 'day', label: 'Day' });
                }
            } else {
                this.monthSize = 'full';
            }
        });
    },
};
</script>
